<template lang="pug">
.card.market-card
  .card-header.bg-more-head.collapse-more(
    :id="'heading-oxthdp-' + childId"
    data-toggle='collapse'
    :data-target="'#collapse-oxthdp-' + childId"
    :aria-controls="'collapse-oxthdp-' + childId"
    aria-expanded=true
  )
    .flex-grow-1.text-ellipsis.text-uppercase.mr-2 {{ leagueName.trim() }}
  .collapse.show(
    :aria-labelledby="'heading-oxthdp-' + childId"
    :id="'collapse-oxthdp-' + childId"
  )
    .card-body.p-0
      .market-card-content
        .two-column
          .two-column-title {{ $t("ui.full_time") }}
          .two-column-content
            .two-column-group
              .two-column-odd-area
                .two-column-odd-area-oddtype
                  p.mb-0 {{ $t("m.ODD_Home") }}
                  p.mb-0 {{ $t("m.ODD_Away") }}
                  p.mb-0 {{ $t("m.ODD_Draw") }}
                .two-column-odd-area-group
                  template(v-if="source['oxt'] && source['oxt'][0] && source['oxt'][0][5] != 0 && source['oxt'][0][5] != ''")
                    OddsItem(:odds="source['oxt'][0]" idx=5 :typ="oddsType" dataType="2" :details="source")
                  template(v-else)
                    OddsDisabled
                  template(v-if="source['oxt'] && source['oxt'][0] && source['oxt'][0][6] != 0 && source['oxt'][0][6] != ''")
                    OddsItem(:odds="source['oxt'][0]" idx=7 :typ="oddsType" dataType="2" :details="source")
                  template(v-else)
                    OddsDisabled
                  template(v-if="source['oxt'] && source['oxt'][0] && source['oxt'][0][7] != 0 && source['oxt'][0][7] != ''")
                    OddsItem(:odds="source['oxt'][0]" idx=6 :typ="oddsType" dataType="2" :details="source")
                  template(v-else)
                    OddsDisabled
            .two-column-group
              .two-column-odd-area
                .two-column-odd-area-oddtype
                  p.mb-0 {{ $t("m.ODD_Home") }}
                  p.mb-0 {{ $t("m.ODD_Away") }}
                  p.mb-0 &nbsp;
                .two-column-odd-area-group
                  template(v-if="source['hdp'] && source['hdp'][0] && source['hdp'][0][9] != 0 && source['hdp'][0][10] != 0 && source['hdp'][0][9] != '' && source['hdp'][0][10] != ''")
                    OddsItem(:odds="source['hdp'][0]" :idx="source['hdp'][0][7] == 1 ? '10' : '9'" :typ="oddsType" dataType="1" mode="hdp" count="0" :details="source" homeAway="1")
                  template(v-else)
                    OddsDisabled
                  template(v-if="source['hdp'] && source['hdp'][0] && source['hdp'][0][9] != 0 && source['hdp'][0][10] != 0 && source['hdp'][0][9] != '' && source['hdp'][0][10] != ''")
                    OddsItem(:odds="source['hdp'][0]" :idx="source['hdp'][0][7] == 1 ? '9' : '10'" :typ="oddsType" dataType="1" mode="hdp" count="0" :details="source" homeAway="2")
                  template(v-else)
                    OddsDisabled
                  .odd-box
</template>

<script>
import OddsItem from "@/components/mobile/main/xitem/oddsItem";
import OddsDisabled from "@/components/mobile/main/xitem/oddsDisabled";
import mixinHDPOUOdds from "@/library/mixinHDPOUOdds";

export default {
  components: {
    OddsItem,
    OddsDisabled
  },
  mixins: [mixinHDPOUOdds],
  props: {
    mode: {
      type: Number
    },
    childId: {
      type: Number
    }
  },
  computed: {
    leagueName() {
      var result = this.source["league"].split(" - ");
      if (result.length >= 2) {
        if (result.length - 2 != 0) {
          if (result.length <= 5) {
            return result[result.length - 2] + " - " + result[result.length - 1];
          }
          if (result.length <= 6) {
            return result[result.length - 3] + " - " + result[result.length - 2] + " - " + result[result.length - 1];
          }
        }
        return result[result.length - 1];
      }
      return this.source["league"];
    }
  }
}
</script>